"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import AICheckWorkspace from "@/components/aicheck/AICheckWorkspace";
import { projectDetailPath } from "@/lib/aicheck/routes";

function EntryContent() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const id = searchParams.get("id");

  // Legacy deep links (`/?id=123&...`) now live on the project page.
  useEffect(() => {
    if (!id) return;
    const rest = new URLSearchParams(searchParams);
    rest.delete("id");
    const qs = rest.toString();
    router.replace(`${projectDetailPath(id)}${qs ? `&${qs}` : ""}`);
  }, [id, searchParams, router]);

  if (id) {
    return (
      <div className="p-8 text-sm text-gray-500">
        案件ページへ移動しています…
      </div>
    );
  }

  return <AICheckWorkspace variant="entry" />;
}

export default function AICheckPage() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-[400px] text-gray-500">
          Loading...
        </div>
      }
    >
      <EntryContent />
    </Suspense>
  );
}
